import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialLaboratoryConfidentialityDeedState: Dtos.LaboratoryConfidentialityDeed & IRegistrationFormState = {
    id: null,
    laboratoryId: null,
    laboratory: null,
    name: null,
    location: null,
    dateOfDeed: null,
    dateFullyExecuted: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false
}

export interface ILaboratoryConfidentialityDeedReduxFormState {
    id: IFieldState<number>,
    laboratoryId: IFieldState<number>,
    laboratory: IFieldState<Dtos.Laboratory>,
    name: IFieldState<string>,
    location: IFieldState<string>,
    dateOfDeed: IFieldState<string>,
    dateFullyExecuted: IFieldState<string>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>
}
